package com.neurobs.ccabserver.administrator

import com.neurobs.ccab.CCABServer
import com.neurobs.ccabserver.administrator.components.Main
import com.neurobs.ccabserver.administrator.contexts.ResourceURLContext
import com.neurobs.ccabserver.administrator.view.ControllerSessionView
import com.neurobs.js.aws.Amplify
import com.neurobs.js.aws.Cognito
import com.neurobs.js.ccab.UserManager
import com.neurobs.js.ccab.{DatabaseErrorLogger, RelativeJSCCABServer}
import com.neurobs.js.view.{Gui, SoundView}
import com.neurobs.js.dom.{DOMGui, DOMSoundView}
import com.neurobs.util.PrintLogger
import org.scalajs.dom.{document, window}
import org.scalajs.dom.BeforeUnloadEvent
import scalatags.JsDom.all.div
import slinky.web.ReactDOM

import scala.concurrent.ExecutionContext.Implicits.global
import scala.scalajs.js

object App {
	private val mainDivID = "mainDiv"

	def getHiddenInputValue(id: String): String = {
		document.getElementById(id).getAttribute(name = "value")
	}

	def getImageFolder(): String = {
		val example = getHiddenInputValue(id = "image_example")
		example.substring(0, example.lastIndexOf('/'))
	}

	def main(args: Array[String]): Unit = {

		// Prompt on browser window close if any controller sessions
		// are present.
		window.onbeforeunload = { (e: BeforeUnloadEvent) =>
			if (document.getElementsByName(ControllerSessionView.viewElementName).length > 0) {
				e.preventDefault()
				e.returnValue = "Confirm exit?"
			}
		}

		val mainDiv = document.getElementById(mainDivID)
		val reactDiv = div().render
		mainDiv.appendChild(reactDiv)

		val logger = new DatabaseErrorLogger(new PrintLogger(printDebug = false))

		val server: CCABServer = RelativeJSCCABServer()

		Amplify.configureAuthenticatorCSS()

		val clientSetting = js.Dynamic.global.clientSettings
		Cognito.configure(Cognito.Config(
			region = clientSetting.cognito.region.asInstanceOf[String],
			clientId = clientSetting.cognito.clientId.asInstanceOf[String],
			userPoolId = clientSetting.cognito.userPoolId.asInstanceOf[String]
		))

		val resources = Map(
			ResourceURLContext.Resource.HorizontalLogo -> getHiddenInputValue(id = "header_logo"),
			ResourceURLContext.Resource.CircleLogoWithText -> getHiddenInputValue(id = "login_logo")
		)

		val sounds: SoundView = new DOMSoundView(alertUrl = getHiddenInputValue(id = "flit_flut"), notificationUrl = getHiddenInputValue(id = "cloud"))

		val gui: Gui = new DOMGui(mainDiv, sounds, getImageFolder())

		UserManager() map { userManager =>
			val monitor = new InactivityMonitor(
				userManager = userManager
			)

			ReactDOM.render(
				component = Main(
					resources = resources,
					server = server,
					gui = gui,
					logger = logger,
					userManager = userManager
				),
				target = reactDiv
			)
		}
	}
}
